/**
 * Sorts practices by descending score, then alphabetically by title if scores are equal.
 *
 * @param {Array} practices - Scored practice objects with `score` and `title`.
 * @returns {Array} Sorted array of practices.
 */
export const sortPractices = (practices = []) => {
  return [...practices].sort((a, b) => {
    // Sort descending by score
    if (b.score !== a.score) {
      return b.score - a.score;
    }

    // Tiebreaker: alphabetically by title
    return a.title.localeCompare(b.title, undefined, { numeric: true });
  });
};
